// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"f2660302","245":"0965c127","301":"8fe67afd","372":"c032affe","404":"737a0650","421":"cb3744d0","507":"c023d6e8","520":"ea2ef471","642":"3c414362","694":"b2d91583","813":"be52ac51","922":"bcd3d7d6","979":"bdfbc32e"}[chunkId] + ".js";
};